import React from 'react';
import { Redirect } from 'react-router-dom';

const NotFound: React.FC = () => {
  return <Redirect to="/"></Redirect>;
};

export default NotFound;
